const uk = {
  7000001: "сітка",
  7000002: "Грід стратегія",
  7000003: "Спот-сітка",
  7000004: "Осцилятор",
  7000005: "Покупка дешевше, продаж дорожче",
  7000006: "Циклічний арбітраж",
  7000007: "Інструмент",
  7000008: "Торгівля копіями ф'ючерсів",
  7000009: "Клік копіювання трейдингу разом заробляємо",

  target_8: "Стратегічний рахунок",
};
export default uk;
